global.openConfirmModal = function (params){
    let modalHtml = `
<div class="modal fade modal-ajax-form" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header pb-0 border-bottom-0">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg></button>
            </div>
            <div class="modal-body py-0">{{ body }}</div>
            <div class="modal-footer py-3 my-0">{{ actions }}</div>
        </div>
    </div>
</div>
`.trim()

    let body = '';

    if(params.icon) {
        //<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg"/>
    }

    if(params.title) {
        body += `<h5 class="modal-title text-center">${params.title}</h5>`
    }
    if(params.message) {
        body += `<p>${params.message}</p>`
    }
    modalHtml = modalHtml.replace('{{ body }}', body);

    let actions = '';

    if(typeof params.cancel === 'object') {
        if(params.cancel.link){
            actions += `<a href="${params.cancel.link}" class="btn btn-light d-flex align-items-center gap-2">${params.cancel.title || 'Uždaryti'}</a>`
        }else{
            actions += `<button data-type="cancel" class="btn btn-light d-flex align-items-center gap-2">${params.cancel.title || 'Uždaryti'}</button>`
        }
    }

    if(typeof params.ok === 'object') {

        let title = '';
        if(params.startIcon){
            title += `<i class='${params.ok.startIcon}'></i>`
        }
        title += params.ok.title || 'OK';
        if(params.ok.icon || params.ok.endIcon){
            title += `<i class='${params.ok.icon || params.ok.endIcon}'></i>`
        }

        if(params.ok.link){
            actions += `<a href="${params.ok.link}" class="btn btn-primary d-flex align-items-center gap-2" tabindex="0">${title}</a>`
        }else{
            actions += `<button data-type="ok" class="btn btn-primary d-flex align-items-center gap-2" tabindex="0">${title}</button>`
        }
    }

    if(actions){
        modalHtml = modalHtml.replace('{{ actions }}', actions);
    }

    let $modal = $(modalHtml);
    if(!actions){
        $modal.find('.modal-footer').remove();
    }
    $('body').append($modal);

    let modalEl = $modal[0]

    let modal_inst = new bootstrap.Modal(modalEl);
    modal_inst.show();

    modalEl.addEventListener('hidden.bs.modal', function () {
        $modal.remove();
        if(params.onCloseCallback){
            params.onCloseCallback()
        }
    });
    $modal.on("click", "button", function (e) {
        if(this.dataset.type === 'ok' && params.ok.callback){
            params.ok.callback()
        }else if(this.dataset.type === 'cancel' && params.cancel.callback){
            params.cancel.callback()
        }
        modal_inst.hide()
    });
}